const header = () => {

    const openSearch = document.querySelector(".open-search");
    const closeSearch = document.querySelector(".close-search");
    const headerTop = document.querySelector(".header-top");

    openSearch.addEventListener("click", () => {
        if(window.innerWidth <= 991) {
            headerTop.classList.add("mobile-search-active");
        }
    });

    closeSearch.addEventListener("click", () => {
        if(window.innerWidth <= 991) {
            headerTop.classList.remove("mobile-search-active");
        }
    });

}

export default header;